// Media query for orientation-based responsive behavior
export const ORIENTATION_LANDSCAPE = '(orientation: landscape)';

// Background video dimensions (16:9 landscape / 9:16 portrait)
export const VIDEO_DESKTOP_WIDTH = 1920;
export const VIDEO_DESKTOP_HEIGHT = 1080;
export const VIDEO_MOBILE_WIDTH = 720;
export const VIDEO_MOBILE_HEIGHT = 1280;

// Content video dimensions
// Landscape orientation: 3:4 portrait aspect ratio (596 * 4/3 = 794.67 ≈ 795)
export const CONTENT_VIDEO_LANDSCAPE_WIDTH = 596;
export const CONTENT_VIDEO_LANDSCAPE_HEIGHT = 795;
// Portrait orientation: 3:2 landscape aspect ratio (720 / 3 * 2 = 480)
export const CONTENT_VIDEO_PORTRAIT_WIDTH = 720;
export const CONTENT_VIDEO_PORTRAIT_HEIGHT = 480;

// Theme class mapping
export const THEME_CLASS_MAP = {
  theme0: 'bg-background text-foreground',
  theme1: 'bg-hero-accent text-primary-foreground',
} as const;
